<template>
  <div id="package" class="main-wrapper">
    <div class="section-header">选择课时包和人数</div>
    <div class="select-area">
      <div class="select-wrapper">
        <h2 class="title">教师搭配</h2>
        <div class="radio">
          <div
            v-for="(item, key) in teacher_typeArr"
            :key="key"
            :class="{ selected: teacher_type == item.index }"
            class="radio-item-wrapper"
            @click="teacher_type = item.index"
          >
            <div class="radio-item">
              <div class="radio-circle">
                <i class="anyteachicon anyteach-check" />
              </div>
              <span class="radio-text">{{ item.content }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="select-wrapper">
        <h2 class="title">课程时长</h2>
        <div class="radio">
          <div
            v-for="(item, key) in durationArr"
            :key="key"
            :class="{ selected: duration == item }"
            class="radio-item-wrapper"
            @click="duration = item"
          >
            <div class="radio-item">
              <div class="radio-circle">
                <i class="anyteachicon anyteach-check" />
              </div>
              <span class="radio-text">{{ item }} 小时</span>
            </div>
          </div>
        </div>
      </div>
      <div class="select-wrapper">
        <h2 class="title">课时包</h2>
        <div v-for="(item, key) in packages" :key="key" class="radio radio-multiline">
          <div
            :class="{ selected: sessions == item }"
            class="radio-item-wrapper"
            @click="sessions = item"
          >
            <span class="special" v-if="key === packages.length - 1">
              <i class="anyteachicon anyteach-jizan" />最划算
            </span>
            <div class="radio-item">
              <div class="radio-circle">
                <i class="anyteachicon anyteach-check" />
              </div>
              <span class="radio-text">
                {{ item.regular }} 次课
                <span v-if="item.extra">+ 赠送 {{ item.extra }} 次课</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="select-wrapper">
        <h2 class="title">拼课人数</h2>
        <div class="radio">
          <div
            v-for="(item, key) in paxArr"
            :key="key"
            :class="{ selected: pax == item }"
            class="radio-item-wrapper"
            @click="pax = item"
          >
            <div class="radio-item">
              <div class="radio-circle">
                <i class="anyteachicon anyteach-check" />
              </div>
              <span class="radio-text">{{ item.content }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="teacher_type && duration && sessions && pax"
      class="action-button"
      @click="changeState()"
    >
      下一步
    </div>
    <div @click="$toast('请选择所有选项')" v-else class="action-button button-disabled">下一步</div>
  </div>
</template>
<script>
export default {
  name: "Package",
  props: ["packages"],
  data() {
    return {
      sessions: this.packages[this.packages.length - 1],
      packageArr: [
        { index: 1, regular: 4, extra: 0 },
        { index: 2, regular: 12, extra: 4 },
        { index: 3, regular: 48, extra: 12 },
        { index: 4, regular: 96, extra: 36 },
      ],
      teacher_type: 2,
      teacher_typeArr: [{ index: 2, content: "全外教课" }, { index: 1, content: "中教 + 外教" }],
      duration: 2,
      durationArr: [1, 1.5, 2],
      pax: "",
      paxArr: [{ index: 1, content: "1 至 2 人" }, { index: 2, content: "3 至 8 人" }],
    }
  },
  watch: {
    sessions: function (val) {
      this.$emit("update", { sessions: val })
    },
    duration: function (val) {
      this.$emit("update", { duration: val })
    },
    teacher_type: function (val) {
      this.$emit("update", { teacher_type: val })
    },
    pax: function (val) {
      this.$emit("update", { pax: val })
    },
  },
  methods: {
    changeState(step = 1) {
      this.$emit("update", {
        sessions: this.sessions,
        duration: this.duration,
        teacher_type: this.teacher_type,
        pax: this.pax,
      })
      this.$emit("state", step)
    }
  }
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";
@import "../../../../static/css/prog-form.scss";
@import "../../../../static/css/radio.scss";

#package {
  padding-bottom: 100px;
}
.special {
  position: absolute;
  @include avenir-demi();
  font-size: 12px;
  top: -5px;
  right: -35px;
  transform: scale(0.9);
  color: $red;
  $color1: $red;
  $color2: #fe7070;
  background: $red;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(to right, $color1, $color2);
  i {
    padding-right: 2px;
  }
}
</style>
